import { render, staticRenderFns } from "./ArticlesInner.vue?vue&type=template&id=0a1b6111&"
import script from "./ArticlesInner.vue?vue&type=script&lang=js&"
export * from "./ArticlesInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports